/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

// TODO: this is copied from manager app, find proper home for it to be shared
import { FlowBlock } from '@staffino/model';

type BlockVisitor = {
  enter?: (block: FlowBlock) => void;
  exit?: (block: FlowBlock) => void;
};

export default function accept(block: FlowBlock, visitor: BlockVisitor) {
  visitor.enter?.(block);
  if ('children' in block && Array.isArray(block.children)) {
    for (let i = 0; i < block.children.length; i += 1) {
      const child = block.children[i];
      accept(child as FlowBlock, visitor);
    }
  }
  visitor.exit?.(block);
}
